module.exports = "<template>\n    <table class=\"table table-condensed table-hover\">\n        <slot></slot>\n    </table>\n</template>";